/**
 * Generic card renderer used as the card-view alternative to a table.
 *
 * props:
 *  - items:        array of rows
 *  - getKey:       (item) => unique key
 *  - renderTitle:  (item) => node  (card heading)
 *  - renderSubtitle?: (item) => node
 *  - fields:       [{ label, value: (item) => node, hideEmpty?: bool }]
 *  - renderActions?: (item) => node  (e.g. a menu / buttons; clicks are isolated)
 *  - onClick?:     (item) => void
 *  - loading?:     bool
 *  - emptyText?:   string
 */
const DataCards = ({ items, getKey, renderTitle, renderSubtitle, fields = [], renderActions, onClick, loading, emptyText, layout = "grid" }) => {
    if (loading) {
        return <div className="data-cards-empty"><div className="loader" role=""></div></div>;
    }
    if (!items || items.length === 0) {
        return <div className="data-cards-empty">{emptyText || "Records not found"}</div>;
    }
    return (
        <div className={`data-cards layout-${layout === "list" ? "list" : "grid"}`}>
            {items.map((item, idx) => (
                <div
                    key={getKey ? getKey(item) : idx}
                    className={`data-card${onClick ? " clickable" : ""}`}
                    onClick={onClick ? () => onClick(item) : undefined}
                >
                    {(renderTitle || renderActions) && (
                        <div className="data-card-head">
                            <div className="data-card-titles">
                                {renderTitle && <span className="data-card-title">{renderTitle(item)}</span>}
                                {renderSubtitle && <span className="data-card-subtitle">{renderSubtitle(item)}</span>}
                            </div>
                            {renderActions && (
                                <div className="data-card-actions" onClick={(e) => e.stopPropagation()}>
                                    {renderActions(item)}
                                </div>
                            )}
                        </div>
                    )}
                    <div className="data-card-body">
                        {fields.map((f, i) => {
                            const val = f.value(item);
                            if (f.hideEmpty && (val === null || val === undefined || val === "")) return null;
                            return (
                                <div key={i} className="data-card-row">
                                    <span className="data-card-label">{f.label}</span>
                                    <span className="data-card-val">{val === null || val === undefined || val === "" ? "—" : val}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DataCards;
